require('./ui-bootstrap-tpls');
module.exports = 'ui.bootstrap';



//////////////////
// WEBPACK FOOTER
// /app/~/angular-ui-bootstrap/index.js
// module id = 6
// module chunks = 0